import React from "react";
import { TimePicker } from "antd";
import dayjs from "dayjs";
import "./SnapshotCountdown.scss";

/**
 * Snapshot 倒數計時器組件
 *
 * 顯示在 CheckAssistant 頁面右上角
 * 倒數 15 分鐘後自動更新資料
 * 當使用者填寫聯絡表單時暫停倒數
 *
 * @param {number} remainingSeconds - 剩餘秒數 (0-900)
 * @param {boolean} isPaused - 是否暫停倒數 (預設 false)
 */
const SnapshotCountdown = ({ remainingSeconds = 0, isPaused = false }) => {
  /**
   * 將秒數轉換為 dayjs 時間格式
   * 例: 900 秒 → 15:00, 599 秒 → 09:59
   */
  const getTimeValue = () => {
    if (remainingSeconds <= 0) {
      return dayjs().startOf("day");
    }
    return dayjs().startOf("day").add(remainingSeconds, "second");
  };

  // 如果 remainingSeconds 為 0,表示尚未開始或已停止
  if (remainingSeconds === 0) {
    return null;
  }

  return (
    <div className="snapshot-countdown">
      <div className="snapshot-countdown__label">
        {isPaused ? "暫停倒數" : "下次更新"}
      </div>
      <TimePicker
        value={getTimeValue()}
        format="mm:ss"
        disabled
        className="snapshot-countdown__timer"
        suffixIcon={null}
        showNow={false}
      />
      <div className="snapshot-countdown__frequency">＊更新頻率：15 分鐘</div>
    </div>
  );
};

export default SnapshotCountdown;
